/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('reprint', {
                parent: 'app',
                url: '/reprint?code&page&size',
                params: {
                    page: "0",
                    size: "10",
                    code: "",
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/reprint/reprint.html',
                        controller: 'reprintCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['reprint']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabReprint('reprint')
                            }]
                        }
                    }
                }
            })
    }
})();
